export class AdditionalDocResponse {
    public documentId: number = 0;
    public documentType: string = '';
    public objectType: string = '';
    public docGUID: string = '';
    public docNameWithExtension: string = '';
    public verificationStatus: string = '';
    public licenseState: string = '';
    public licenseNumber: string = '';
    public expiryMessage: string = '';
    public name: string = '';
    public doesNotExpire : boolean = false;
    public docExtType: string = '';
    public effectiveDTTM: Date = new Date();
    public expiryDTTM: Date = new Date();    
  }


 